import { lazyRouteComponent } from "@tanstack/react-router";
import { ScanEye } from "lucide-react";

import type { PageDef } from "@/app/registry";

export const BRING = ["cas", "broker", "manual"] as const;
export type BringTab = (typeof BRING)[number];

export interface PortfolioSearch {
  /** How to bring the portfolio (the tab open in step 1); default the CAS upload. */
  how?: BringTab;
  /** "sample": show the X-ray of the made-up sample portfolio. */
  view?: "sample";
}

export function parsePortfolioSearch(s: Record<string, unknown>): PortfolioSearch {
  const out: PortfolioSearch = {};
  if (BRING.includes(s.how as BringTab)) out.how = s.how as BringTab;
  if (s.view === "sample") out.view = "sample";
  return out;
}

export const pages: PageDef[] = [
  {
    path: "/app/portfolio",
    proOnly: true,
    title: "Portfolio X-ray",
    component: lazyRouteComponent(() => import("./PortfolioPage"), "PortfolioPage"),
    nav: { label: "Portfolio X-ray", icon: ScanEye, group: "Premium", order: 6 },
    validateSearch: parsePortfolioSearch,
  },
];
